import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function toQuery(params = {}) {
  const qp = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qp.set(key, value);
    }
  });

  return qp.toString();
}

async function parseErrorResponse(res, fallbackMessage) {
  const contentType = res.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const body = await res.json().catch(() => ({}));
    const error = new Error(body?.message || fallbackMessage);
    error.status = res.status;
    error.response = { data: body };
    throw error;
  }

  const body = await res.text().catch(() => '');
  const error = new Error(`Error ${res.status}: ${body || fallbackMessage}`);
  error.status = res.status;
  throw error;
}

export async function getGestionCartera(filters = {}) {
  const query = toQuery(filters);
  const url = `${API_BASE_URL}/api/admin/gestion-cartera${query ? `?${query}` : ''}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden gestionar cartera.');
  }

  if (!res.ok) {
    await parseErrorResponse(res, 'Error al consultar la cartera activa');
  }

  return res.json();
}

export async function getEmpleadosAsesores() {
  const res = await fetchWithAuth(`${API_BASE_URL}/api/admin/asesores/getasesores`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden consultar empleados.');
  }

  if (!res.ok) {
    await parseErrorResponse(res, 'Error al consultar empleados');
  }

  return res.json();
}

export async function reasignarAsesorCartera({ prestamosIds, asesorDestinoId }) {
  const res = await fetchWithAuth(`${API_BASE_URL}/api/admin/gestion-cartera/reasignar-asesor`, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id_asesor_destino: Number(asesorDestinoId),
      prestamos_ids: prestamosIds.map(Number),
    }),
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden reasignar créditos.');
  }

  if (!res.ok) {
    await parseErrorResponse(res, 'Error al reasignar créditos');
  }

  return res.json();
}